import { render, staticRenderFns } from "./lender-submission-changes-table.vue?vue&type=template&id=4cf60969"
import script from "./lender-submission-changes-table.vue?vue&type=script&lang=js"
export * from "./lender-submission-changes-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports